import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';

@Component({
  selector: 'piqet-angular-new-admin-misc-simulation',
  templateUrl: './new-admin-misc-simulation.component.html',
  styleUrls: ['./new-admin-misc-simulation.component.scss'],
})
export class NewAdminMiscSimulationComponent {
  headerData: any;
  headerName = '';
  modalLabel: any;
  miscSimulationData: any;
  miscSimulationForm!: FormGroup;
  miscSimulationAddEditForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  organizationlist: any;
  conversionList: any;
  regionList: any;
  selectOrganization: any;
  regionData: any;
  selectRegion: any;
  setIndicatorData: any;
  indicatorList: any;
  isHideDropDown!: boolean;
  isDisabledDropDown!: boolean;
  @Output() saveNewMiscSimulationEvent = new EventEmitter<any>();

  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    private administratorService: AdministratorService
  ) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['headerName'];
    this.miscSimulationData = this.modal?.modalService?.config?.initialState?.['newMiscSimulation'];
    this.isDisabledDropDown = this.modalLabel == 'Review misc simulation detail' ? true : false;
    const placeHolderOrganization = {
      name: 'All organization',
    };

    const newOrganizationlist = [placeHolderOrganization].concat(
      this.miscSimulationData.organizationList
    );

    this.regionList = this.miscSimulationData.regionItems;
    this.indicatorList = this.miscSimulationData.indicatiorList;
    this.organizationlist = newOrganizationlist;
    this.conversionList = this.miscSimulationData.energyProcessItems;
    this.organizatioListFunction();
    this.getRegionData();
  }

  ngOnInit(): void {
    const form = [];
    for (let i = 0; i < this.indicatorList.length; i++) {
      form[this.indicatorList[i].name] = new FormControl(
        this.miscSimulationData.indicatiorList[i].defaultValue || 0,
        Validators.required
      );
    }
    this.miscSimulationForm = new FormGroup(form);
    this.miscSimulationAddEditForm = this.formBuilder.group({
      conversion: [this.miscSimulationData.energyProcessId || null, Validators.required],
      region: [null, Validators.required],
      organizationName: [
        this.miscSimulationData.organizationId || this.organizationlist[0] || null,
      ],
    });
    this.setFormData();
  }

  onClose() {
    this.modal.close();
  }

  onChange(value: any) {
    this.miscSimulationAddEditForm.controls['region'].reset();
    if (!!value?.id) {
      this.administratorService.GetRegionsForMiscSimulation(value.id).subscribe((data: any) => {
        const newRegionlist = data.data;
        this.regionData = newRegionlist;
      });
    } else {
      this.regionData = [];
    }
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  async organizatioListFunction() {
    await this.organizationlist?.map((item: any) => {
      if (item.id == this.miscSimulationData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }
  async getRegionData() {
    await this.regionList.map((item: any) => {
      if (item.id == this.miscSimulationData.regionId) {
        return (this.selectRegion = item);
      }
    });
  }
  setFormData() {
    this.miscSimulationAddEditForm.patchValue({
      region: this.selectRegion,
      organizationName: this.selectOrganization,
    });
  }

  onSave() {
    this.submitted = true;
    if (
      this.miscSimulationAddEditForm.controls['region'].value?.name == '--Select Region-- ' ||
      (this.activatedRoute == 'processing-data-conversion' &&
        !this.miscSimulationAddEditForm.controls['region'].value?.name)
    ) {
      return;
    }
    if (
      this.miscSimulationAddEditForm.status == 'VALID' &&
      this.miscSimulationForm.status == 'VALID'
    ) {
      const entires = Object.entries(this.miscSimulationForm.value);
      const resultArray: any = [];
      let i = {};
      const entiresArray = this.miscSimulationData.indicatiorList.map((obj: any, index: any) => ({
        ...obj,
        ...entires[index],
      }));
      entiresArray.forEach((event: any, index: any) => {
        i = {
          indicatorId: event.indicatorId,
          name: event.name,
          unit: event.unit,
          defaultValue: event[1],
          equivalencyUnits: event.equivalencyUnits,
          multiplier: event.multiplier,
        };
        resultArray.push(i);
      });
      const conversionPayload = {
        energyProcessId: this.miscSimulationAddEditForm.controls['conversion'].value,
        regionId:
          this.miscSimulationAddEditForm.controls['region'].value?.id ||
          this.miscSimulationData.regionId,
        organizationId:
          this.miscSimulationAddEditForm.controls['organizationName'].value?.name ==
            'All organization' ||
          this.miscSimulationAddEditForm.controls['organizationName'].value?.name == undefined
            ? null
            : this.miscSimulationAddEditForm.controls['organizationName'].value?.id,
        indicatiorList: resultArray,
      };
      this.saveNewMiscSimulationEvent.emit(conversionPayload);
      this.onClose();
    }
  }
}
